import { render, staticRenderFns } from "./CustomFieldsTable.vue?vue&type=template&id=14b0b13e"
import script from "./CustomFieldsTable.vue?vue&type=script&lang=js"
export * from "./CustomFieldsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports